import React, { useEffect, useState } from "react";

const PreviousDataBox = (props) => {
  const {
    myOrderdata,
    lensItems,
    setRegularLens,
    handleLAddRLeave,
    handleLAddLLeave,
    openPreviousDataList,
    setIssavingLens
  } = props;
  useEffect(() => {
    console.log("myOrderdata", myOrderdata);
    console.log("lensItems", lensItems);
  }, []);

  // const [showTooltip, setShowTooltip] = useState(false);

  function formatDate(dateString) {
    // Manually parse "DD-MM-YYYY"
    const [day, month, year] = dateString.split("-").map(Number);
    const date = new Date(year, month - 1, day); // Month is 0-indexed

    // Get the day, month, year
    const formattedDay = String(date.getDate()).padStart(2, "0");
    const formattedMonth = date.toLocaleString("default", { month: "short" });
    const formattedYear = date.getFullYear();

    // Return format: dd Mon- yyyy
    return `${formattedDay}\u00A0${formattedMonth}- ${formattedYear}`;
  }

  const SetDataInLens = (e, data) => {
    ;
    if (data) {
      setTimeout(() => {
        if (data.RAdd) {
          handleLAddRLeave(data.RAdd);
        }
        if (data.LAdd) {
          handleLAddLLeave(data.LAdd);
        }
        setIssavingLens(true)
        setRegularLens((prevState) => ({
          ...prevState,
          SPH_DV_R: data.RSphDv || "",
          CYL_DV_R: data.RCylDv || "",
          AXS_DV_R: data.RAxisDv || "",
          VN_DV_R: data.RVnDv || "",
          ADD_R: data.RAdd || "",
          SPH_DV_L: data.LSphDv || "",
          CYL_DV_L: data.LCylDv || "",
          AXS_DV_L: data.LAxisDv || "",
          VN_DV_L: data.LVnDv || "",
          ADD_L: data.LAdd || "",
        }));
        setTimeout(() => {
          openPreviousDataList();
        }, 10);

      }, 0);
    }
  };

  return (
    <div className="prevLensDataBox">
      {myOrderdata &&
        myOrderdata
          .filter(
            (item, index, self) =>
              index === self.findIndex((t) => t.id === item.id)
          )
          .map((data, index) => { 
            return (
              <div className="prevLensDataBox-box">
                <div className="prevLensDataBox-top">
                  <span>
                    <p>
                      Sale order/ Sale Invoice : <span>{data.id}</span>
                    </p>
                  </span>
                  <span>
                    <p>
                      {" "}
                      Bill Series: <span>{data.vouchSeries || "0"}</span>
                    </p>
                  </span>
                  <span>
                    <p>
                      Bill Number : <span>{data.voucherNo}</span>
                    </p>
                  </span>
                  <span>
                    <p>
                      {" "}
                      Bill Date : <span>{formatDate(data.date)}</span>
                    </p>
                  </span>
                  <span>
                    <p>
                      Delivery Date :{" "}
                      <span>{formatDate(data.deliveryDate)}</span>
                    </p>
                  </span>
                </div>
                <div className="prevLensDataBox-bottom">
                  <div className="prevLensDataBox-bottom-left">
                    <table className="itemAndBillWiseCard-tbl1">
                      <thead>
                        <tr>
                          <th>S No</th>
                          <th style={{ width: "50%" }}>Item</th>
                          <th>Qty</th>
                          <th>Price</th>
                        </tr>
                      </thead>
                    </table>

                    <div className="scrollable-tbody">
                      <table className="itemAndBillWiseCard-tbl1">
                        <tbody>
                          {myOrderdata &&
                            Object.values(
                              myOrderdata
                                .sort((a, b) => Number(b.id) - Number(a.id))
                                .filter((item1) => item1.id === data.id)
                                .reduce((acc, item) => {
                                  const { id, price } = item;

                                  if (!acc[id]) {
                                    acc[id] = {
                                      uniqueId: id,
                                      products: [],
                                      total: 0,
                                      childCount: 0,
                                    };
                                  }

                                  acc[id].products.push(item);
                                  acc[id].total += parseInt(price);
                                  acc[id].childCount += 1;

                                  return acc;
                                }, {})
                            )
                              .flatMap((group) =>
                                group.products
                                  .sort(
                                    (a, b) => Number(a.t2_id) - Number(b.t2_id)
                                  )
                                  .map((product, i) => (
                                    <tr key={product.t2_id || i}>
                                      <td>{i + 1}</td>
                                      <td style={{ width: "50%" }}>
                                        {product.itemName}
                                      </td>
                                      <td>{product.qty}</td>
                                      <td>{product.price}</td>
                                    </tr>
                                  ))
                              )
                              .slice(0, 5)}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="prevLensDataBox-bottom-right">
                    <table className="itemAndBillWiseCard-tbl1">
                      <thead>
                        <tr>
                          <th>Type</th>
                          <th></th>
                          <th>SPH</th>
                          <th>CYL </th>
                          <th>AXIS</th>
                          <th>ADD</th>
                        </tr>
                      </thead>
                      {myOrderdata &&
                        (() => {
                          const match = myOrderdata
                            .sort((a, b) => Number(b.id) - Number(a.id))
                            .find((item1) => item1.id === data.id);

                          if (!match || !match.lensDetails) {
                            return (
                              <tbody>
                                <tr>
                                  <td colSpan={6}>No lens data found</td>
                                </tr>
                              </tbody>
                            );
                          }

                          let lensDetail = [];

                          try {
                            lensDetail = JSON.parse(match.lensDetails);
                          } catch (e) {
                            return (
                              <tbody>
                                <tr>
                                  <td colSpan={6}>No lens data found</td>
                                </tr>
                              </tbody>
                            );
                          }

                          if (
                            !Array.isArray(lensDetail) ||
                            lensDetail.length === 0
                          ) {
                            return (
                              <tbody>
                                <tr>
                                  <td colSpan={6}>No lens data found</td>
                                </tr>
                              </tbody>
                            );
                          }

                          return lensDetail.map((data, index) => {
                            let contact = {};
                            let transpose = {};

                            try {
                              contact = JSON.parse(data.Contact || "{}");
                              transpose = JSON.parse(data.Transpose || "{}");
                            } catch (e) {
                              contact = {};
                              transpose = {};
                            }

                            return (
                              <tbody key={index}>
                                {/* LENS Section */}
                                <tr>
                                  <td rowSpan={2} style={{overflow:"visible"}}>
                                    LENS
                                    <button
                                      // onMouseEnter={() => setShowTooltip(true)}
                                      // onMouseLeave={() => setShowTooltip(false)}
                                      onClick={(e) => SetDataInLens(e, data)}
                                      className="lensSelectButton"
                                    >
                                      USE
                                      {/* {showTooltip && (
                                        <div className="custom-tooltip">
                                          Ctrl+Click to open in a new tab
                                        </div>
                                      )} */}
                                    </button>
                                  </td>
                                  <td>DV-R</td>
                                  <td>{data?.RSphDv || "-"}</td>
                                  <td>{data?.RCylDv || "-"}</td>
                                  <td>{data?.RAxisDv || "-"}</td>
                                  <td>{data?.RAdd || "-"}</td>
                                </tr>
                                <tr>
                                  <td>DV-L</td>
                                  <td>{data?.LSphDv || "-"}</td>
                                  <td>{data?.LCylDv || "-"}</td>
                                  <td>{data?.LAxisDv || "-"}</td>
                                  <td>{data?.LAdd || "-"}</td>
                                </tr>

                                {/* Contact Section */}
                                <tr>
                                  <td rowSpan={2}>Contact</td>
                                  <td>DV-R</td>
                                  <td>{contact?.SPH_DV_R || "-"}</td>
                                  <td>{contact?.CYL_DV_R || "-"}</td>
                                  <td>{contact?.AXS_DV_R || "-"}</td>
                                  <td>{contact?.ADD_R || "-"}</td>
                                </tr>
                                <tr>
                                  <td>DV-L</td>
                                  <td>{contact?.SPH_DV_L || "-"}</td>
                                  <td>{contact?.CYL_DV_L || "-"}</td>
                                  <td>{contact?.AXS_DV_L || "-"}</td>
                                  <td>{contact?.ADD_L || "-"}</td>
                                </tr>

                                {/* Transpose Section */}
                                {/* <tr>
                                  <td rowSpan={2}>Transpose</td>
                                  <td>DV-L</td>
                                  <td>{transpose?.SPH_DV_L || "-"}</td>
                                  <td>{transpose?.CYL_DV_L || "-"}</td>
                                  <td>{transpose?.AXS_DV_L || "-"}</td>
                                  <td>{transpose?.ADD_L || "-"}</td>
                                </tr>
                                <tr>
                                  <td>DV-R</td>
                                  <td>{transpose?.SPH_DV_R || "-"}</td>
                                  <td>{transpose?.CYL_DV_R || "-"}</td>
                                  <td>{transpose?.AXS_DV_R || "-"}</td>
                                  <td>{transpose?.ADD_R || "-"}</td>
                                </tr> */}
                              </tbody>
                            );
                          });
                        })()}
                    </table>
                  </div>
                </div>
              </div>
            );
          })}
    </div>
  );
};

export default PreviousDataBox;
